import { call, put, takeEvery } from "redux-saga/effects";
import { GET_SHARE_TRIP_FAILED, GET_SHARE_TRIP_REQUESTED, GET_SHARE_TRIP_SUCCESS, GET_TRIP_FAILED, GET_TRIP_REQUESTED, GET_TRIP_SUCCESS } from "resources/actionTypes";
import { shareTripApi, tripApi } from "services/TripService";

function* fetchTrip(action) {
  try {
    const payload = action.payload || {}
    const userTrip = yield call(tripApi,payload);
    yield put({ type: GET_TRIP_SUCCESS, userTrip: userTrip });
  } catch (e) {
    yield put({ type: GET_TRIP_FAILED, message: e.message });
  }
}

export function* tripSaga() {
  yield takeEvery(GET_TRIP_REQUESTED, fetchTrip);
}

function* fetchShareTrip(action){
  try{
    const payload = action.payload || {}
    const userShareTrip = yield call(shareTripApi, payload);
    yield put({type: GET_SHARE_TRIP_SUCCESS, userShareTrip:userShareTrip});
  } catch(e) {
    yield put({type:GET_SHARE_TRIP_FAILED, message:e.message})
  }
  }
 export function* shareTripSaga() {
  yield takeEvery(GET_SHARE_TRIP_REQUESTED, fetchShareTrip);
 }